<!--联系我们-联系资环-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="walkinto" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in contatctList' :key='item.id'>
              <el-image
                style="width: 100%;height: 25vw"
                v-if="item.fullPathUrl != null"
                :src="item.fullPathUrl"
              />
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--联系我们标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>联系我们
          </h1>
          <p>Contact Us</p>
        </div>
      </div>
      <!--联系我们-->

      <el-row  :span="24" class="box-width contact_box" :style="bgStyle">
          <el-col :md="12" :sm="12" :xs="24">
            <div class="us_text">
              <h3>{{ zhInfo.name}}</h3>
              <p v-for="item in zhInfo.zhInfoDetailsList" :key="item.id">{{ item.content }}</p>
            </div>
          </el-col>
            <el-col :md="12" :sm="12" :xs="24">
              <el-card>
                <!--form表单-->
                <p>请留下您的联系方式和需求，我们将第一时间联系您！</p>
                <el-form class="el_form" :model="form2" ref="consultRef2" :rules="rules2">
                  <el-form-item prop="unitName">
                    <el-input class="consult_inp" placeholder="单位" v-model="form2.unitName"></el-input>
                  </el-form-item>
                  <el-form-item prop="fullName">
                    <el-input class="consult_inp" placeholder="姓名" v-model="form2.fullName"></el-input>
                  </el-form-item>
                  <el-form-item prop="phone">
                    <el-input class="consult_inp" placeholder="电话" v-model="form2.phone"></el-input>
                  </el-form-item>
                  <el-form-item prop="demand">
                    <el-input class="consult_inp" placeholder="需求" type="textarea" v-model="form2.demand"></el-input>
                  </el-form-item>
                  <el-button size="small" type="primary" @click="onSubmit2" style="float: right;margin-bottom: 5px;">提 交</el-button>
                </el-form>
              </el-card>
            </el-col>
      </el-row>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="25vw" class='carousel_class'>
            <el-carousel-item v-for='item in contatctList' :key='item.id'>
              <el-image
                style="width: 100%;height: 25vw"
                v-if="item.fullPathUrl != null"
                :src="item.fullPathUrl"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="boxs_content">
          <div class='title'>
            <h1>
              <i class="el-icon-caret-right"></i>
              联系我们
              <span>contact us</span>
            </h1>
          </div>
          <p>{{ zhInfo.name}}</p>
          <p v-for="item in zhInfo.zhInfoDetailsList" :key="item.id">{{ item.content }}</p>
        </div>
        <!--提交需求-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                提交需求
                <span>Submit Requirements</span>
              </h1>
            </div>
            <!--form表单-->
            <el-form class="el_form" :model="form" ref="consultRef" :rules="rules">
              <el-form-item prop="unitName">
                <el-input class="consult_inp" placeholder="单位" v-model="form.unitName"></el-input>
              </el-form-item>
              <el-form-item prop="fullName">
                <el-input class="consult_inp" placeholder="姓名" v-model="form.fullName"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input class="consult_inp" placeholder="电话" v-model="form.phone"></el-input>
              </el-form-item>
              <el-form-item prop="demand">
                <el-input class="consult_inp" placeholder="需求" type="textarea" v-model="form.demand"></el-input>
              </el-form-item>
              <el-button size="small" type="primary" @click="onSubmit">提 交</el-button>
            </el-form>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { addDemand, findBanner, findZhInfo } from '@api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      form: {
        unitName: '',
        fullName: '',
        phone: '',
        demand: ''
      },
      form2: {
        unitName: '',
        fullName: '',
        phone: '',
        demand: ''
      },
      zhInfo: {},
      backgroundImageUrl: require('../../assets/images/index/gz.jpg'),
      activeName: 'second',
      fit: 'cover',
      url1: require('@assets/images/index/chanping1.png'),
      src: require('@assets/images/index/baidu.png'),
      src1: require('@assets/images/index/guge.png'),
      honorUrc: require('@assets/images/aboutZh/zs3.png'),
      url: require('@assets/images/aboutZh/zs3.png'),
      contatctList: [],
      rules: {
        unitName: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        demand: [{ required: true, message: '请输入需求', trigger: 'blur' }]
      },
      rules2: {
        unitName: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        demand: [{ required: true, message: '请输入需求', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.getZhInfo()
  },
  mounted () {
  },
  computed: {
    bgStyle () {
      return {
        backgroundImage: `url(` + this.backgroundImageUrl + `)`
      }
    }
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.contatctList = res.data
      })
    },
    /** 获取资环信息 */
    getZhInfo () {
      findZhInfo().then(res => {
        this.zhInfo = res.data
      }).catch(error => {
        console.error('Error fetching data:', error)
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      let that = this
      this.$refs.consultRef.validate((valid) => {
        if (valid) {
          let params = that.form
          params.tabId = that.tabId
          addDemand(params).then(res => {
            that.$message({
              type: 'success',
              message: res.msg,
              duration: 1000
            })
            that.form = {}
          }).catch(error => {
            console.log('Error submitting form:', error)
          })
        } else {
          return false
        }
      })
    },
    onSubmit2 () {
      let that = this
      this.$refs.consultRef2.validate((valid) => {
        if (valid) {
          let params = that.form2
          params.tabId = that.tabId
          addDemand(params).then(res => {
            that.$message({
              type: 'success',
              message: res.msg,
              duration: 1000
            })
            that.form2 = {}
          }).catch(error => {
            console.log('Error submitting form:', error)
          })
        } else {
          return false
        }
      })
    }
  }
}

</script>
